module.exports = {
    "LOGGING_LEVEL": "INFO",
    "BLOCKSTACK": {
        "SUBDOMAIN_REGISTRAR": "https://registrar.cruxpay.com",
        "GAIA_HUB": "https://hub.cruxpay.com",
        "BNS_NODES": ["https://core.blockstack.org", "https://bns.cruxpay.com"]
    }
};